// Native Shopify language form; no country, currency or cart changes.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.takoo-language__form')) return;
  const url = new URL(window.location.href);
  url.searchParams.delete('locale');
  const field = form.querySelector('input[name="return_to"]');
  if (field) field.value = url.pathname + url.search + url.hash;
});

(() => {
  if (document.documentElement.lang !== 'zh-CN' || document.querySelector('[data-takoo-foundation]') || !document.querySelector('main product-form-component')) return;
  let queued = false;
  const observedChatRoots = new WeakSet();
  const overlaps = (a, b) => a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8;
  const check = () => {
    queued = false;
    const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
    const runtimeRoot = chatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
    // Shopify can move the launcher into its runtime after the shell loads.
    for (const root of [chatRoot, runtimeRoot]) {
      if (root && !observedChatRoots.has(root)) {
        new MutationObserver(schedule).observe(root, {childList: true, subtree: true});
        observedChatRoots.add(root);
      }
    }
    const launcher = chatRoot?.querySelector('[part="activator"]') || runtimeRoot?.querySelector('[part="activator"]');
    const rect = launcher?.getBoundingClientRect();
    const controls = document.querySelectorAll('main form[action*="/cart/add"] button[type="submit"], main .variant-option__button-label, main shopify-accelerated-checkout, main .sticky-add-to-cart__button');
    const blocked = !!rect && rect.width > 0 && Array.from(controls).some(control => {
      const r = control.getBoundingClientRect();
      const style = getComputedStyle(control);
      return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && style.visibility !== 'hidden' && style.display !== 'none' && overlaps(rect, r);
    });
    document.documentElement.classList.toggle('takoo-zh-purchase-chat-overlap', blocked);
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(check); } };
  addEventListener('scroll', schedule, {passive: true});
  addEventListener('resize', schedule, {passive: true});
  addEventListener('load', schedule, {once: true});
  document.addEventListener('change', schedule);
  document.addEventListener('click', schedule);
  document.addEventListener('transitionend', schedule);
  new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
  customElements.whenDefined('shopify-chat').then(() => { schedule(); setTimeout(schedule, 500); });
  schedule();
})();
